/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_MenuInputs */

const en_user_menu = /** @type {(inputs: User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User menu`)
};

/**
* | output |
* | --- |
* | "User menu" |
*
* @param {User_MenuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const user_menu = /** @type {((inputs?: User_MenuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_MenuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_user_menu(inputs)
});